import React from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from 'components/commons/Icon';
import PropTypes from 'prop-types';

import { DropWrapper, DropButton } from './styles';

const DropToggle = ({ onPress, isOpen, openTitle, closeTitle }) => {
  return (
    <DropWrapper>
      <DropButton onClick={onPress}>
        <Icon
          name="chartDropArrow"
          style={
            isOpen
              ? { transform: 'rotate(180deg)', marginRight: '10px' }
              : { marginRight: '10px' }
          }
        />
        {isOpen ? (
          <FormattedMessage id={closeTitle} />
        ) : (
          <FormattedMessage id={openTitle} />
        )}
      </DropButton>
    </DropWrapper>
  );
};

DropToggle.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
  openTitle: PropTypes.string.isRequired,
  closeTitle: PropTypes.string.isRequired,
};

export default DropToggle;
